/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MemberGroupDto } from './memberGroupDto.schema';

export const IReadOnlyListOfMemberGroupDto = zod.array(zod.lazy(() => MemberGroupDto));

export type IReadOnlyListOfMemberGroupDto = zod.input<typeof IReadOnlyListOfMemberGroupDto>;
export type IReadOnlyListOfMemberGroupDtoOutput = zod.output<typeof IReadOnlyListOfMemberGroupDto>;
